import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CREAM_CHIP_IN_VALUES = createFcmDetails('cream_chip_in_values', {
	owner: 'TBD',
	context: 'PSF promote or share page',
	description:
		'Defines which amount to set in the "chip in" button. Should be in the country\'s currency (e.g. "5" for "5 euros")',
	import: false,
});
